import AddDealershipForm from './AddDealershipForm';

export default AddDealershipForm;
